<template>
    <div class="pt-2" v-if="cartCount()">
        <CartSummary></CartSummary>
        <div class="row align-items-center justify-content-bewteen">
            <div class="col-md-4 col-3">
                <router-link :to="{name: 'cart'}" class="action-button action-button-big-desktop d-flex justify-content-start">
                    <a class="main-btn d-none d-md-block">{{ capitalize($t('back')) }}</a>
                    <a class="main-btn back d-block d-md-none"><div class="icon arrow-icon back-icon"></div></a>
                </router-link>
            </div>

            <div class="col col-md-6 ml-md-auto">
                <button dusk="cart-next-step" type="submit" class="next-step btn btn-purple w-100" :class="{'disabled': nextStepDisabled()}" @click="validate()">
                    {{ $t('btn_choose_payment_method') }}
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import CartSummary from './CartSummary.vue'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
    name: 'BillingButtons',
    components: {
         CartSummary,
    },
    props: {
        hasCompletedBillingFields: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState('cart', [
            'orderDetails'
        ])
    },
    methods: {

        ...mapGetters('cart', [
            'cartCount',
        ]),

        validate() {
            if(this.nextStepDisabled()) {
                this.$emit('nextStepAttempt');
                return false;
            }

            this.$router.push({name : "payment-method"});
        },

        nextStepDisabled() {
            if(!this.hasCompletedBillingFields) {
                return true;
            }

            if(this.$store.getters['auth/getLoginStatus']) {

                if(!this.orderDetails.profile_id) {

                    return true;
                }
            }

            return false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .back{
        width: auto;
        padding: 13px 22px !important;

        .back-icon {
            transform:rotateZ(90deg)
        }
    }

    .disabled{
        background-color: #9EABED;
        border-radius: 4px;
        &:hover{
            cursor: not-allowed;
        }
    }

</style>
